var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,3c-4.95852,0 -9,4.04148 -9,9v26c0,4.95852 4.04148,9 9,9h26c4.95852,0 9,-4.04148 9,-9v-26c0,-4.95852 -4.04148,-9 -9,-9zM12,5h26c3.87748,0 7,3.12252 7,7v26c0,3.87748 -3.12252,7 -7,7h-26c-3.87748,0 -7,-3.12252 -7,-7v-26c0,-3.87748 3.12252,-7 7,-7zM38,7c-1.09546,0 -2,0.90455 -2,2v3c0,1.09545 0.90454,2 2,2h3c1.09546,0 2,-0.90455 2,-2v-3c0,-1.09545 -0.90454,-2 -2,-2zM38,9h3v3h-3zM25,12c-3.66834,0 -6.98377,1.54091 -9.35156,4h-7.64844c-0.55226,0.00006 -0.99994,0.44774 -1,1v20c0,3.30163 2.69837,6 6,6h24c3.30163,0 6,-2.69837 6,-6v-20c-0.00006,-0.55226 -0.44774,-0.99994 -1,-1h-7.64844c-2.36779,-2.45909 -5.68322,-4 -9.35156,-4zM25,14c6.07348,0 11,4.92652 11,11c0,6.07348 -4.92652,11 -11,11c-6.07348,0 -11,-4.92652 -11,-11c0,-6.07348 4.92652,-11 11,-11zM25,16c-0.14111,-0.00126 -0.28089,0.02737 -0.41016,0.08398c-4.75816,0.22743 -8.58984,4.10206 -8.58984,8.91602c0,4.95939 4.04163,9 9,9c4.95837,0 9,-4.04061 9,-9c0,-4.81263 -3.82962,-8.6866 -8.58594,-8.91602c-0.13047,-0.05716 -0.27164,-0.08579 -0.41406,-0.08398zM9,18h5.06836c-1.30205,2.02409 -2.06836,4.42397 -2.06836,7c0,7.15852 5.84148,13 13,13c7.15852,0 13,-5.84148 13,-13c0,-2.57603 -0.76631,-4.97591 -2.06836,-7h5.06836v19c0,2.22037 -1.77963,4 -4,4h-24c-2.22038,0 -4,-1.77963 -4,-4zM25,18c3.87764,0 7,3.12139 7,7c0,3.87861 -3.12236,7 -7,7c-3.87764,0 -7,-3.12139 -7,-7c0,-3.87861 3.12236,-7 7,-7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.5b3ce2b219d44c1065c663f45d9869d7.svg";
export { ForwardRef as ReactComponent };